var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.613391 5.38797L3.30672 9.15464C3.53339 9.47464 3.90006 9.66797 4.29339 9.66797C5.28672 9.66797 5.86006 8.54797 5.28672 7.7413L3.33339 5.0013L5.28672 2.2613C5.86672 1.45463 5.28672 0.334635 4.29339 0.334635C3.90006 0.334635 3.52672 0.527968 3.30006 0.847969L0.606724 4.61464C0.446724 4.84797 0.446724 5.15463 0.613391 5.38797Z",
    fill: "#A7A9BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.28038 5.38797L7.96705 9.15464C8.20038 9.47464 8.56705 9.66797 8.96038 9.66797C9.95372 9.66797 10.5337 8.54797 9.95372 7.7413L8.00038 5.0013L9.95372 2.2613C10.5337 1.45463 9.95372 0.334635 8.96038 0.334635C8.56705 0.334635 8.19372 0.527968 7.96705 0.847969L5.27372 4.61464C5.11372 4.84797 5.11372 5.15463 5.28038 5.38797Z",
    fill: "#A7A9BC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHover);
export default __webpack_public_path__ + "static/media/hover.b98f75ae184dd591e7522601a983ae4b.svg";
export { ForwardRef as ReactComponent };